import actions from './actions'
import getters from './getters'
import mutations from './mutations'
// import cardType from '../cardType'

const state = {
    currentParams: {
        qtype: '',
        projectIdx: [],
        month: ''
    },
    status: {
        getCustomDashboard: '',
        saveCustomDashboard: '',
        resetCustomDashboard: '',
        hasInvoice: '',
        download: {
            simpleExcel: '',
            detailCSV: '',
            invoicePDF: ''
        },
        invoiceMonths: '',
        summaryStatistics: '',
        summaryMonths: '',
        summaryRegions: '',
        summaryWeeks: '',
        summaryDates: '',
        summaryProducts: '',
        compareEstimated: '',
        comparePrevMonth: '',
        totalCost: '',
        detail: '',
        cost: ''
    },
    customDashboard: [],
    customDashboardIdx: null,
    hasInvoice: false,
    download: {
        simpleExcel: false,
        detailCSV: false,
        invoicePDF: false
    },
    invoiceMonths: [],
    summaryStatistics: {
        products: 0,
        lineitems: 0
    },
    summaryMonths: {
        list: [],
        maxCost: 0
    },
    summaryRegions: {
        lastMonthRegions: [],
        thisMonthRegions: []
    },
    summaryWeeks: {
        weeks: [],
        days: [],
        yKeys: [],
        weeklyCost: {}
    },
    summaryDates: {
        lineChartData: [],
        barChartData: [],
        labels: [],
        costOfAfterThisMonth: 0,
        dates: []
    },
    summaryProducts: {
        thisMonthProducts: [],
        lastMonthProducts: []
    },
    compareEstimated: {},
    comparePrevMonth: {},
    totalCost: {},
    detail: {},
    cost: null,
    widget: {
        cardModel: []
    },
    editDashboard: []
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
